import Vue from 'vue';
import VueRouter from 'vue-router';
import LogInOut from '../views/LogInOut.vue';
// import Vuetify from 'vuetify';
import Home from '../views/Home.vue';
import Users from '../views/Users.vue';
import Brands from '../views/Brands.vue';
import Packaging from '../views/Packaging.vue';
import Vouchers from '../views/Vouchers.vue';
import Providers from '../views/Providers.vue';
import Categories from '../views/Categories.vue';

import Machines from '../views/Machines.vue';
import Transactions from '../views/Transactions.vue';
import TransactionsOutgoing from '../views/TransactionsOutgoing.vue';
import Admins from '../views/Admins.vue';
import Changes from '../views/Changes.vue';
import Audit from '../views/Audit.vue';
import ReviewUndefined from '../views/ReviewUndefined.vue';
import ManualPoints from '../views/ManualPoints.vue';
import Notifications from '../views/Notifications.vue';
import store from '../store';
import Vouchercheck from '@/views/Vouchercheck.vue';
import Successvouchercheck from '@/views/Successvouchercheck.vue';

// Vue.use(Vuetify);

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LogInOut,
  },
  {
    path: '/voucher-check/:voucherCode',
    name: 'VoucherCheck',
    component: Vouchercheck,
    props: true,
   },
   {
    path: '/Successvouchercheck',
     name: 'Successvouchercheck',
     component: Successvouchercheck,
     props: true,
   },
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
  },
  {
    path: '/brands',
    name: 'brands',
    component: Brands,
  },
  {
    path: '/vouchers',
    name: 'vouchers',
    component: Vouchers,
  },
  {
    path: '/providers',
    name: 'providers',
    component: Providers,
  },
  {
    path: '/categories',
    name: 'categories',
    component: Categories,
  },
  {
    path: '/packaging',
    name: 'packaging',
    component: Packaging,
  },
  {
    path: '/machines',
    name: 'machines',
    component: Machines,
  },
  {
    path: '/transactions',
    name: 'transactions',
    component: Transactions,
  },
  {
    path: '/transactionsoutgoing',
    name: 'transactionsoutgoing',
    component: TransactionsOutgoing,
  },
  {
    path: '/admins',
    name: 'admins',
    component: Admins,
  },
  {
    path: '*',
    redirect: '/login',
  },
  {
    path: '/changes',
    name: 'changes',
    component: Changes,
  },
  {
    path: '/audit',
    name: 'audit',
    component: Audit,
  },
  {
    path: '/reviewundefined',
    name: 'reviewundefined',
    component: ReviewUndefined,
  },
  {
    path: '/users/total',
    name: 'totalusers',
    component: Users,
  },
  {
    path: '/users/active',
    name: 'activeusers',
    component: Users,
  },
  {
    path: '/users/nonactive',
    name: 'nonactiveusers',
    component: Users,
  },
  {
    path: '/users/banned',
    name: 'bannedusers',
    component: Users,
  },
  {
    path: '/manualpoints',
    name: 'manualpoints',
    component: ManualPoints,
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');

  const voucherPath = '/voucher-check/';

  if (to.path.toLowerCase().startsWith(voucherPath)) {
    return next();
  }

  if (to.path.startsWith('/Successvouchercheck')) {
    return next();
  }
  if (to.fullPath !== '/login') {
    if (!store.state.accessToken || store.state.accessToken === 'undefined') {
      return next('/login');
    }
  }
  if (to.fullPath === '/login') {

    if (store.state.accessToken && store.state.accessToken !== 'undefined') {

      return next('/home');
    }
  }

  next();
});

export default router;
